import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
export var AuthInfo = /*#__PURE__*/function () {
  function AuthInfo(headerName, token) {
    _classCallCheck(this, AuthInfo);

    this.privHeaderName = headerName;
    this.privToken = token;
  }

  _createClass(AuthInfo, [{
    key: "headerName",
    get: function get() {
      return this.privHeaderName;
    }
  }, {
    key: "token",
    get: function get() {
      return this.privToken;
    }
  }]);

  return AuthInfo;
}();